"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _cartIconSVG = _interopRequireDefault(require("./cartIconSVG.js"));

var _index = require("../../utils/index");

var _wixSdkOOI = _interopRequireDefault(require("./wixSdkOOI"));

var _artstorePageManager = _interopRequireDefault(require("./artstorePageManager"));

var _consts = require("../consts");

var _photographyClientLib = require("@wix/photography-client-lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CART_ICONS_TYPES = {
  CART: 'cart',
  OUT_LINE: 'cartOutline',
  BAG: 'bag',
  BAG_OUT_LINE: 'bagOutline',
  TEXT: 'cartText'
};
var DEFAULT_CART_COLOR = '#384AD3';
var DEFUALT_CART_SIZE = '35px';

var CartIcon = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CartIcon, _Component);

  function CartIcon(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = _objectSpread({}, _this.getCartStyles(props));
    return _this;
  }

  var _proto = CartIcon.prototype;

  _proto.getCartIconType = function getCartIconType(cartIcon) {
    switch (cartIcon) {
      case 0:
        return CART_ICONS_TYPES.CART;

      case 1:
        return CART_ICONS_TYPES.OUT_LINE;

      case 2:
        return CART_ICONS_TYPES.BAG;

      case 3:
        return CART_ICONS_TYPES.BAG_OUT_LINE;

      case 4:
        return CART_ICONS_TYPES.TEXT;

      default:
        return CART_ICONS_TYPES.BAG_OUT_LINE;
    }
  };

  _proto.getCartIconText = function getCartIconText(publicData) {
    if (publicData === void 0) {
      publicData = {};
    }

    if (publicData.COMPONENT) {
      return publicData.COMPONENT && publicData.COMPONENT.cartIconText;
    }

    return '';
  };

  _proto.getCartStyles = function getCartStyles(props) {
    var _props$props$host$sty = _objectSpread(_objectSpread({}, props), props.host.style),
        _props$props$host$sty2 = _props$props$host$sty.styleParams,
        colors = _props$props$host$sty2.colors,
        numbers = _props$props$host$sty2.numbers,
        publicData = _props$props$host$sty.publicData;

    return {
      cartIcon: this.getCartIconType(numbers.cartIcon),
      cartIconColor: this.getCartIconColor(colors.cartIconColor),
      cartIconText: this.getCartIconText(publicData)
    };
  };

  _proto.updateCartStyles = function updateCartStyles(props) {
    var newStyles = this.getCartStyles(props);
    this.setState(_objectSpread({}, newStyles));
  };

  _proto.getCartIconColor = function getCartIconColor(cartIconColor) {
    return cartIconColor ? cartIconColor.value : this.getDefualtCartColor();
  };

  _proto.getDefualtCartColor = function getDefualtCartColor() {
    try {
      var style = this.props.host.style;
      return style.siteColors.find(function (color) {
        return color.reference === 'color-8';
      }).value;
    } catch (e) {
      return DEFAULT_CART_COLOR;
    }
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode || e.charCode) {
      case 32: // space

      case 13:
        // enter
        e.preventDefault();
        e.stopPropagation();
        this.props.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, true);
        return false;

      default:
        break;
    }

    return true;
  };

  _proto.getCartRelevantStyles = function getCartRelevantStyles(props) {
    var _props$props$host$sty3 = _objectSpread(_objectSpread({}, props), props.host.style),
        _props$props$host$sty4 = _props$props$host$sty3.styleParams,
        cartIconColor = _props$props$host$sty4.colors,
        cartIcon = _props$props$host$sty4.numbers,
        publicData = _props$props$host$sty3.publicData;

    return {
      cartIconColor: cartIconColor,
      cartIcon: cartIcon,
      cartIconText: publicData && publicData.COMPONENT
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevStyles = this.getCartRelevantStyles(prevProps);
    var currentStyles = this.getCartRelevantStyles(this.props);

    if (JSON.stringify(prevStyles) !== JSON.stringify(currentStyles)) {
      this.updateCartStyles(this.props);
    }
  };

  _proto.initWixSdkIfNeeded = function initWixSdkIfNeeded() {
    if (!this.wixSdk) {
      var _this$props = this.props,
          baseUrl = _this$props.baseUrl,
          sectionsUrls = _this$props.sectionsUrls,
          visitorId = _this$props.visitorId,
          metaSiteId = _this$props.metaSiteId,
          locale = _this$props.locale,
          _this$props$host = _this$props.host,
          formFactor = _this$props$host.formFactor,
          style = _this$props$host.style;

      var getDeviceType = function getDeviceType(type) {
        return type === 'mobile' || type === 'tablet' ? 'mobile' : 'desktop';
      };

      this.wixSdk = (0, _wixSdkOOI["default"])({
        baseUrl: baseUrl,
        sectionsUrls: sectionsUrls,
        visitorId: visitorId,
        metaSiteId: metaSiteId,
        locale: locale,
        deviceType: getDeviceType(formFactor.toLowerCase()),
        style: style
      });
    }
  };

  _proto.initPageManagerIfNeeded = function initPageManagerIfNeeded() {
    if (!this.pageManager) {
      var _this$props$this$prop = _objectSpread(_objectSpread({}, this.props), this.props.host),
          locale = _this$props$this$prop.locale,
          connectedProviders = _this$props$this$prop.connectedProviders,
          viewMode = _this$props$this$prop.viewMode,
          baseUrl = _this$props$this$prop.baseUrl;

      var isMobile = _index.utils.isMobile();

      this.pageManager = new _artstorePageManager["default"]({
        isMobile: isMobile,
        viewMode: viewMode.toLowerCase(),
        connectedProviders: connectedProviders,
        locale: locale,
        deviceType: isMobile ? 'mobile' : 'desktop',
        baseUrl: baseUrl,
        closeFullscreen: function closeFullscreen() {}
      });
    }
  };

  _proto.initTranslationsIfNeeded = function initTranslationsIfNeeded() {
    var isEmptyObject = function isEmptyObject(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    var translations = this.props.translations;

    if (isEmptyObject(_photographyClientLib.translationUtils.translations) && translations) {
      _photographyClientLib.translationUtils.setTranslations(this.props.translations);
    }
  };

  _proto.reportAppLoaded = function reportAppLoaded() {
    try {
      var tryToReportAppLoaded = this.props.tryToReportAppLoaded;
      tryToReportAppLoaded();
    } catch (e) {}
  };

  _proto.initIfNeeded = function initIfNeeded() {
    this.reportAppLoaded();
    this.initWixSdkIfNeeded();
    this.initPageManagerIfNeeded();
    this.initTranslationsIfNeeded();
  };

  _proto.openCart = function openCart() {
    var _this$props2 = this.props,
        storeApi = _this$props2.storeApi,
        setActiveStoreWidget = _this$props2.setActiveStoreWidget;

    if (typeof setActiveStoreWidget === 'function') {
      setActiveStoreWidget();
    }

    storeApi.showCart();
  };

  _proto.getCartIconElement = function getCartIconElement() {
    var _this2 = this;

    var _this$state = this.state,
        cartIcon = _this$state.cartIcon,
        cartIconText = _this$state.cartIconText,
        cartIconColor = _this$state.cartIconColor;
    var _this$props3 = this.props,
        _this$props3$host$dim = _this$props3.host.dimensions,
        width = _this$props3$host$dim.width,
        height = _this$props3$host$dim.height,
        cartItemsCount = _this$props3.cartItemsData.cartItemsCount;
    var style = {
      width: width || DEFUALT_CART_SIZE,
      height: height || DEFUALT_CART_SIZE
    };
    var count = cartItemsCount || 0;
    var cartCount = cartIcon === 'cartText' ? "(" + count + ")" : count;
    return /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        return _this2.openCart();
      },
      onKeyDown: this.handleKeyDown,
      "aria-label": "Cart (" + cartCount + ")",
      role: "button",
      style: style,
      className: "artstore-cart-icon"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'artstore-cart-icon-svg-container'
    }, cartIcon === 'cartText' ? /*#__PURE__*/_react["default"].createElement("div", null, cartIconText) : /*#__PURE__*/_react["default"].createElement(_cartIconSVG["default"], {
      icon: cartIcon,
      color: cartIconColor
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-cart-icon-count"
    }, cartCount));
  };

  _proto.getPagesData = function getPagesData() {
    var _this$props4 = this.props,
        cartItemsData = _this$props4.cartItemsData,
        additionalProviderParams = _this$props4.additionalProviderParams,
        checkoutParams = _this$props4.checkoutParams,
        changeStoreFrameState = _this$props4.changeStoreFrameState,
        storeApi = _this$props4.storeApi,
        consentPolicy = _this$props4.consentPolicy,
        appInstance = _this$props4.appInstance;
    var wixSdk = this.wixSdk;
    return _objectSpread(_objectSpread({}, cartItemsData), {}, {
      additionalProviderParams: additionalProviderParams,
      wixSdk: wixSdk,
      changeStoreFrameState: changeStoreFrameState,
      checkoutParams: checkoutParams,
      storeApi: storeApi,
      consentPolicy: consentPolicy,
      appInstance: appInstance
    });
  };

  _proto.shouldHideCart = function shouldHideCart() {
    var _this$props5 = this.props,
        connectedProviders = _this$props5.connectedProviders,
        additionalProviderParams = _this$props5.additionalProviderParams;
    var isFreeArtStore = !!(additionalProviderParams && additionalProviderParams.freeArtStore);
    return !connectedProviders || isFreeArtStore;
  };

  _proto.render = function render() {
    var pagesState = this.props.pagesState;

    if (this.shouldHideCart()) {
      return null;
    }

    this.initIfNeeded();
    var dom = [this.getCartIconElement()];
    dom.push(this.pageManager.getPages(this.getPagesData(), pagesState, 'cart'));
    return /*#__PURE__*/_react["default"].createElement("div", null, dom);
  };

  return CartIcon;
}(_react.Component);

exports["default"] = CartIcon;